import React from 'react';
import { Panel, PanelTheme, PanelBorderRadius, PanelBorderStyle, Button, ButtonTheme } from '@apply/components';

interface BrokerNotYetActivatedPanelProps {
    onRefreshUser?: () => void;
}

export const BrokerNotYetActivatedPanel: React.FC<BrokerNotYetActivatedPanelProps> = ({ onRefreshUser }) => {
    const refreshUserStatus = async () => {
        if (onRefreshUser) {
            onRefreshUser();
        }
    };

    return (
        <>
            <div className='scrollable-content'>
                <Panel
                    theme={PanelTheme.White}
                    borderRadius={PanelBorderRadius.Medium}
                    borderStyle={PanelBorderStyle.Solid}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                            padding: '20px',
                        }}
                    >
                        <h1>
                            <strong>BFI is reviewing your account.</strong>
                        </h1>
                        <br />
                        <h3>
                            You will be notified as soon as this review is complete. Until complete, this function is unavailable.
                        </h3>
                        <br />
                        <br />
                        <strong>Please check back in 24 hours.</strong>
                        <br />
                        <br />
                        <Button
                            id='refreshStatusButton'
                            theme={ButtonTheme.Primary}
                            handleClick={() => refreshUserStatus()}
                            width='200px'
                        >
                            Refresh My Status
                        </Button>
                    </div>
                </Panel>
            </div>
        </>
    );
};
